import React, { useEffect, useState } from 'react';
import API from '../api';
import { differenceInCalendarDays, parseISO } from 'date-fns';

export default function Leads() {
  const [rows, setRows]         = useState([]);
  const [dropdowns, setDropdowns] = useState({});
  const [filters, setFilters]   = useState({ assignee: '', status: '' });
  const [newRow, setNewRow]     = useState({});

  // Load sheet & dropdowns
  useEffect(() => {
    (async () => {
      const [rRes, dRes] = await Promise.all([
        API.get('/api/leads'),
        API.get('/api/dropdowns'),
      ]);
      const leadRows = rRes.data || [];
      setRows(leadRows);
      setDropdowns(dRes.data || {});
      if (leadRows[0]) {
        const hdr = leadRows[0];
        setNewRow(hdr.reduce((o, h) => ({ ...o, [h]: '' }), {}));
      }
    })();
  }, []);

  if (!rows.length) return <div style={{ padding: 20 }}>Loading leads…</div>;

  const header   = rows[0];
  const dataRows = rows.slice(1).filter(r => r.some(c => c !== ''));
  const now      = new Date();

  // Filter dropdown options
  const assignees = dropdowns['Assigned To'] || [];
  const statuses  = dropdowns['Status']      || [];

  // Filtered data
  const filtered = dataRows.filter(r =>
    (!filters.assignee || r[header.indexOf('Assigned To')] === filters.assignee) &&
    (!filters.status   || r[header.indexOf('Status')]      === filters.status)
  );

  // Add new lead
  const handleAdd = async e => {
    e.preventDefault();
    await API.post('/api/leads', { row: header.map(h => newRow[h] || '') });
    const r2 = await API.get('/api/leads');
    setRows(r2.data || []);
    setNewRow(header.reduce((o, h) => ({ ...o, [h]: '' }), {}));
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Leads</h2>

      {/* Add Lead */}
      <form onSubmit={handleAdd}
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(140px,1fr))',
          gap: 12, marginBottom: 20
        }}
      >
        {header.map(h => {
          const key = h.toLowerCase();
          if (key.includes('date')) {
            return (
              <input
                key={h}
                type="date"
                value={newRow[h]}
                onChange={e => setNewRow(n => ({ ...n, [h]: e.target.value }))}
              />
            );
          }
          if (key.includes('notes') || key.includes('summary')) {
            return (
              <textarea
                key={h}
                placeholder={h}
                value={newRow[h]}
                onChange={e => setNewRow(n => ({ ...n, [h]: e.target.value }))}
                style={{ minHeight: '2em' }}
              />
            );
          }
          if (dropdowns[h]) {
            return (
              <select
                key={h}
                value={newRow[h]}
                onChange={e => setNewRow(n => ({ ...n, [h]: e.target.value }))}
              >
                <option value="">{h}</option>
                {dropdowns[h].map(v => (
                  <option key={v} value={v}>{v}</option>
                ))}
              </select>
            );
          }
          return (
            <input
              key={h}
              type="text"
              placeholder={h}
              value={newRow[h]}
              onChange={e => setNewRow(n => ({ ...n, [h]: e.target.value }))}
            />
          );
        })}
        <button type="submit" className="btn btn-primary">Add Lead</button>
      </form>

      {/* Filters */}
      <div className="filter-bar">
        <select
          value={filters.assignee}
          onChange={e => setFilters(f => ({ ...f, assignee: e.target.value }))}
        >
          <option value="">All Assignees</option>
          {assignees.map(a => <option key={a} value={a}>{a}</option>)}
        </select>
        <select
          value={filters.status}
          onChange={e => setFilters(f => ({ ...f, status: e.target.value }))}
        >
          <option value="">All Status</option>
          {statuses.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>

      {/* Table */}
      <div className="table-container" style={{ marginTop: 20 }}>
        <table>
          <thead>
            <tr>{header.map((h,i) => <th key={i}>{h}</th>)}</tr>
          </thead>
          <tbody>
            {filtered.map((row,ri) => {
              const dueIdx = header.findIndex(h => /due date/i.test(h));
              let cls = '';
              if (dueIdx>=0 && row[dueIdx]) {
                const diff = differenceInCalendarDays(parseISO(row[dueIdx]), now);
                cls = diff<0 ? 'overdue' : diff<=3 ? 'due-soon' : '';
              }
              return (
                <tr key={ri} className={cls}>
                  {row.map((c,ci) => <td key={ci}>{c}</td>)}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
);
}
